import {
    Injector,
    Type,
} from '@angular/core';
import { IAuthConfig } from '@models';
import { Logger } from '@services/logger/abstract.logger';

import { NonPublicallyNullableStateManager } from 'main/app-state/generics/state-manager';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthConfigAPI } from './auth-config.api';
import { AuthConfigService } from './auth-config.service';

export class AuthConfigManager extends NonPublicallyNullableStateManager<IAuthConfig> implements AuthConfigAPI {
    protected _state = new BehaviorSubject<IAuthConfig | null>(null);

    private _authConfigService: AuthConfigService;

    constructor(
        injector: Injector,
    ) {
        super();

        this._authConfigService = injector.get<AuthConfigService>(AuthConfigService);

        // The Injector doesn't work directly with abstract classes, so manual casting to Type<Logger> has to be done.
        // More details: https://github.com/angular/angular/issues/23611
        this._logStateChanges('Auth Config', injector.get<Logger>(Logger as Type<Logger>));
    }

    public fetch() {
        return this._authConfigService.get()
            .pipe(
                tap(data => this._state.next(data)),
            );
    }

    public get buildVersion() {
        return this.value.serverSettings.build.version;
    }

    public get odataBaseUrl() {
        return `odata`;
    }
}

